import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { displayToast } from "../../components/app/AppToast";
import { usePageLinks } from "../../domains/app/hooks/usePageLinks";
import { apiClient, useApiQuery, useApiRevalidate } from "../../services/api";
import { useWizardSession } from "./wizardSession";

const WIZARD_PATH = "/webapp/private/users/me/juiscigpt-wizard";

/**
 * The Settings entry of the wizard (docs/juiscigpt-wizard.md REQ-21): the
 * invitation card shows again on the JuisciGPT home. Null when the entry does
 * not show: outside the flag (INV-08), in the control group (INV-09), while the
 * state loads, and while a tour runs, which has its pause banner instead.
 */
export function useWizardRestart(): (() => Promise<void>) | null {
  const { t } = useTranslation();
  const history = useHistory();
  const { gptNewChatPageLink } = usePageLinks(null);
  const revalidate = useApiRevalidate();
  const [, setWizardSession] = useWizardSession();
  const query = useApiQuery(WIZARD_PATH, {});
  if (
    query.state !== "success" ||
    query.body.status === "hidden" ||
    query.body.status === "running"
  )
    return null;
  return async () => {
    try {
      await apiClient.post(`${WIZARD_PATH}/restart`, {});
    } catch {
      displayToast(t("Something went wrong. Please try again."), "error");
      return;
    }
    await revalidate(WIZARD_PATH);
    setWizardSession({
      invitation: "restarted",
      composerTouched: false,
      tour: "paused",
    });
    history.push(gptNewChatPageLink());
  };
}
